"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Expandable = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("../../../icons");

var _accordion = require("./accordion");

var styles = _interopRequireWildcard(require("./expandable.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Expandable = _ref => {
  let {
    id,
    header,
    className,
    children
  } = _ref;
  const {
    activeId,
    toggle,
    theme
  } = (0, _react.useContext)(_accordion.AccordionContext);
  const isActive = (0, _react.useMemo)(() => id === activeId, [id, activeId]);
  const wrapperclassName = (0, _react.useMemo)(() => [styles.wrapper, styles[theme], className, isActive ? styles.active : ""].join(" "), [isActive, theme, className]);

  const clickHandler = () => {
    toggle(id);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    className: wrapperclassName
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: styles.button,
    onClick: clickHandler
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.label
  }, header), /*#__PURE__*/_react.default.createElement(_icons.ArrowIcon, {
    className: styles.icon
  })), isActive && /*#__PURE__*/_react.default.createElement("div", {
    className: styles.content
  }, children));
};

exports.Expandable = Expandable;
Expandable.defaultProps = {
  className: ''
};
Expandable.propTypes = {
  id: _propTypes.default.string.isRequired,
  header: _propTypes.default.element.isRequired,
  className: _propTypes.default.string
};